export const metaPixelId = '1100702405600602'

type MetaEventName = 'PageView' | 'ViewContent' | 'InitiateCheckout'

type MetaEventData = Record<string, string | number>

type MetaPixelFunction = {
  (...args: unknown[]): void
  callMethod?: (...args: unknown[]) => void
  queue: unknown[][]
  loaded: boolean
  push: (...args: unknown[]) => void
  version: string
}

declare global {
  interface Window {
    fbq?: MetaPixelFunction
    _fbq?: MetaPixelFunction
  }
}

export function initializeMetaPixel() {
  if (typeof window === 'undefined' || window.fbq?.loaded) {
    return
  }

  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args)
      return
    }

    fbq.queue.push(args)
  } as MetaPixelFunction

  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []
  window.fbq = fbq
  window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  window.fbq('init', metaPixelId)
}

export function trackMetaEvent(
  eventName: MetaEventName,
  eventData?: MetaEventData,
) {
  if (!window.fbq) {
    return
  }

  window.fbq('track', eventName, eventData)
}

export function trackLandingView() {
  trackMetaEvent('ViewContent', {
    content_ids: 'codigo-fitness-sistema-completo',
    content_name: 'Código Fitness — Sistema completo de alimentación saludable',
    content_type: 'product',
    currency: 'USD',
    value: 29.99,
  })
}

export function trackInitiateCheckout() {
  trackMetaEvent('InitiateCheckout', {
    content_ids: 'codigo-fitness-sistema-completo',
    content_name: 'Código Fitness — Sistema completo de alimentación saludable',
    content_type: 'product',
    currency: 'USD',
    value: 29.99,
  })
}
